// @ts-ignore: autogenerated import
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type RadioWidgetQueryVariables = Exact<{ [key: string]: never }>;

export type RadioWidgetQuery = {
	viewer: {
		__typename: 'MangoViewer';
		broadcastService: {
			__typename: 'MangoBroadcastService';
			id: string;
			epg: Array<{
				__typename: 'MangoEPGEntry';
				broadcastEvent: {
					__typename: 'MangoBroadcastEvent';
					start: string | null;
					end: string | null;
					publicationOf:
						| { __typename: 'MangoBestOf'; kicker: string | null; title: string | null }
						| { __typename: 'MangoBoard'; kicker: string | null; title: string | null }
						| { __typename: 'MangoClip'; kicker: string | null; title: string | null }
						| { __typename: 'MangoCreativeWork'; kicker: string | null; title: string | null }
						| { __typename: 'MangoExtra'; kicker: string | null; title: string | null }
						| { __typename: 'MangoGrouping'; kicker: string | null; title: string | null }
						| { __typename: 'MangoImage'; kicker: string | null; title: string | null }
						| { __typename: 'MangoItem'; kicker: string | null; title: string | null }
						| { __typename: 'MangoMakingOf'; kicker: string | null; title: string | null }
						| { __typename: 'MangoPlaylist'; kicker: string | null; title: string | null }
						| { __typename: 'MangoProgramme'; kicker: string | null; title: string | null }
						| { __typename: 'MangoSeason'; kicker: string | null; title: string | null }
						| { __typename: 'MangoSeries'; kicker: string | null; title: string | null }
						| { __typename: 'MangoTrailer'; kicker: string | null; title: string | null }
						| { __typename: 'MangoWebPage'; kicker: string | null; title: string | null }
						| null;
				} | null;
			} | null> | null;
		} | null;
	} | null;
};

export const RadioWidgetDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'RadioWidget' },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'viewer' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'broadcastService' },
									arguments: [
										{
											kind: 'Argument',
											name: { kind: 'Name', value: 'id' },
											value: { kind: 'StringValue', value: 'http://ard.de/ontologies/ard#B5_aktuell', block: false },
										},
									],
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'InlineFragment',
												typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MangoBroadcastService' } },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'epg' },
															arguments: [
																{
																	kind: 'Argument',
																	name: { kind: 'Name', value: 'slots' },
																	value: { kind: 'EnumValue', value: 'CURRENT' },
																},
															],
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'broadcastEvent' },
																		selectionSet: {
																			kind: 'SelectionSet',
																			selections: [
																				{ kind: 'Field', name: { kind: 'Name', value: 'start' } },
																				{ kind: 'Field', name: { kind: 'Name', value: 'end' } },
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'publicationOf' },
																					selectionSet: {
																						kind: 'SelectionSet',
																						selections: [
																							{ kind: 'Field', name: { kind: 'Name', value: 'kicker' } },
																							{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
																						],
																					},
																				},
																			],
																		},
																	},
																],
															},
														},
													],
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<RadioWidgetQuery, RadioWidgetQueryVariables>;
